import { Iata, IataSchema, SupportedLocaleEnum } from '@reward-platform/shared-schemas'
import { isClientDeploymentEnv } from '@reward-platform/utils'
import { DEFAULT_OP_CO, getOpCoMetaConfig, isOpCoEnabledForAvios } from '../config'

export const validateOpCo = (maybeOpCo: unknown) => {
  const opCoParse = IataSchema.safeParse(maybeOpCo)
  if (!opCoParse.success) {
    return DEFAULT_OP_CO
  }
  const isAviosEnabled = isOpCoEnabledForAvios(opCoParse.data)
  if (!isAviosEnabled) {
    return DEFAULT_OP_CO
  }

  return opCoParse.data
}

export const validateOpCoLocale = (opCoCode: Iata, locale: unknown) => {
  const localeParse = SupportedLocaleEnum.safeParse(locale)
  const { localeOptions, defaultLocale } = getOpCoMetaConfig(opCoCode)
  if (!localeParse.success) {
    return defaultLocale
  }

  const shouldEnableMultiLocale = isClientDeploymentEnv(['local', 'dev', 'tst'])
  if (!shouldEnableMultiLocale && !localeOptions.includes(localeParse.data)) {
    return defaultLocale
  }

  return localeParse.data
}

export const validateOpCoMarket = (opCoCode: Iata, market: unknown) => {
  if (!market || typeof market !== 'string') {
    const metaConfig = getOpCoMetaConfig(opCoCode)
    return metaConfig.defaultCountryCode
  }

  return market
}
